import { PropTypes } from "prop-types"

const FormButton = ({ text, onClick }) => {
  return (
    <button
      css={{
        textDecoration: "underline",
        fontSize: "14px",
        height: "32px",
        background: "transparent",
        color: "var(--color-brand)",
        border: "none",
        padding: 0,
        fontWeight: 500,
      }}
      onClick={onClick}
    >
      {text}
    </button>
  )
}

FormButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
}

export default FormButton
